import React from 'react';

interface TextColorProps {
  words?: [string, string, string];
}

const colors = [
  ['#e57605', '#f29b2a'],
  ['#ff6ec7', '#00fffb'],
  ['#faff00', '#00f0ff'],
];

export function TextColor({ words = ['Grave.', 'Assista.', 'Compartilhe.'] }: TextColorProps) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        gap: 'clamp(2rem, 6vw, 6rem)',
        padding: '1rem 0',
      }}
    >
      {words.map((word, i) => (
        <span
          key={word}
          style={{
            fontSize: 'clamp(2rem, 4.5vw, 4.5rem)',
            fontWeight: 800,
            letterSpacing: '-0.04em',
            lineHeight: 1,
            backgroundImage: `linear-gradient(90deg, ${colors[i][0]}, ${colors[i][1]})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            color: 'transparent',
            userSelect: 'none',
            whiteSpace: 'nowrap',
          }}
        >
          {word}
        </span>
      ))}
    </div>
  );
}
